import React from 'react';
import { useSelector } from 'react-redux';

// React Bootstrap
import { Container, Tabs, Tab } from 'react-bootstrap';

// Components
import CountersTable from './CountersTable';

const CountersInfo = () => {
	const { global_data } = useSelector(state => state.global);

	const { counters_data } = useSelector(state => state.counters);

	return (
		<Container>
			<Tabs
				defaultActiveKey='items'
				id='justify-tab-example'
				className='mt-3'
				justify
			>
				<Tab eventKey='items' title={global_data?.counters?.tabItem}>
					<CountersTable data={counters_data.items} />
				</Tab>
				<Tab eventKey='photos' title={global_data?.counters?.tabPhotos}>
					<CountersTable data={counters_data.photos} />
				</Tab>
			</Tabs>
		</Container>
	)
}

export default CountersInfo;
